/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 *
 * Frontend feature flags.
 *
 * All flags default to OFF. To enable in dev, set the corresponding
 * REACT_APP_* env var to "true" in apps/core/.env.local. In Vercel,
 * set the same env var on the project. CRA exposes any REACT_APP_*
 * variable to the bundle at build time.
 */

const readBoolFlag = (envValue) => envValue === 'true';

export const FLAGS = Object.freeze({
  // When true, the WMS simulation showcase exposes a "Run live
  // simulation" affordance that posts to the Modal endpoint stored
  // on the simulation row. When false (default), only the recorded
  // video player is shown.
  LIVE_SIMULATION: readBoolFlag(process.env.REACT_APP_ENABLE_LIVE_SIMULATION),
});

export default FLAGS;
